<template>
  <div class="w-full ao__mt">
    <iframe
      ref="root"
      style="border-radius:12px"
      :src="getSrc()"
      width="100%"
      :height="getHeight()"
      frameBorder="0"
      allowfullscreen=""
      allow="clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
    ></iframe>
  </div>
</template>

<script setup lang="ts">
const {payload} = defineProps<{
  payload?: any
}>()

enum SpotifyType {
  PLAYLIST = 'playlist',
  PODCAST = 'episode',
  UNKNOWN = 'unknown'
}

const root = ref(null)

const getHeight = () => {
  return 352
  if (!root.value) {
    return 352
  }

  return Math.round(root.value.offsetWidth / 624 * 352)
}



const getType = (): SpotifyType => {
  const src = getSrc()
  if (src.includes('playlist')) {
    return SpotifyType.PLAYLIST
  }
  if (src.includes('episode')) {
    return SpotifyType.PODCAST
  }
  return SpotifyType.UNKNOWN
}

const getSrc = () => {
  let src = payload.attributes.src
  if (src.includes('/embed')) {
    return src
  }
  return src.replace('/open.spotify.com/', '/open.spotify.com/embed/')
}
</script>

<style lang="postcss" scoped>
/*.video-container {*/
/*  @apply relative w-full;*/
/*  padding-bottom: 56.25%;*/
/*}*/

/*.video {*/
/*  position: absolute;*/
/*  top: 0;*/
/*  left: 0;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  border: 0;*/
/*}*/
</style>
